module.exports = {"210106001":"昆明湖街道","210106003":"工人村街道","210106005":"七路街道","210106007":"启工街道","210106013":"笃工街道","210106015":"兴华街道","210106018":"兴工街道","210106019":"霁虹街道","210106020":"凌空街道","210106021":"重工街道","210106022":"艳粉街道","210106023":"保工街道","210106024":"兴顺街道","210106025":"贵和街道","210106026":"大青中朝友谊街道","210106027":"翟家街道","210106028":"西三环街道","210106029":"大潘街道","210106030":"彭驿站街道","210106031":"高花街道","210106401":"沈阳市经济技术开发区管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210106.json
// module id = 456
// module chunks = 0